import { Component, Inject, OnInit } from '@angular/core';
import localeCo from '@angular/common/locales/es-CO';
import { registerLocaleData, DOCUMENT } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';
import { domain, pageTexts } from 'src/app/modules/util/constants';
registerLocaleData(localeCo, 'co');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  constructor(private config: PrimeNGConfig, private router: Router, private activatedRoute: ActivatedRoute,
    private titleService: Title, private metaService: Meta, @Inject(DOCUMENT) private document: Document) { }
  
  title = 'MuyComplacientes';
  noIndexLocalities = ['santa-fe', 'san-cristobal', 'usme', 'tunjuelito', 'barrios-unidos', 'los-martires', 
    'la-candelaria', 'sumapaz', 'itagui', 'la-estrella', 'popular', 'santa-cruz', 'manrique', 'aranjuez', 
    'castilla', 'doce-de-octubre', 'robledo', 'villa-hermosa', 'buenos-aires', 'candelaria', 'america', 
    'san-javier', 'guayabal', 'comuna-1', 'comuna-2', 'comuna-3', 'comuna-4', 'comuna-5', 'comuna-6', 
    'comuna-7', 'comuna-8', 'comuna-9', 'comuna-10', 'comuna-11', 'comuna-12', 'comuna-13', 'comuna-14', 
    'comuna-15', 'comuna-16', 'comuna-17', 'comuna-18', 'comuna-19', 'comuna-20', 'comuna-21', 'comuna-22'];

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)).subscribe(() => {
        var rt = this.getChild(this.activatedRoute)
        rt.data.subscribe(data => {
          const locality = rt.snapshot.params['locality'];
          const filter = rt.snapshot.params['filter'];
          if (locality) {
            if (pageTexts[locality])
              this.titleService.setTitle(pageTexts[locality]['metaTitle']);
          } else if (filter) {
            if (pageTexts[filter])
              this.titleService.setTitle(pageTexts[filter]['metaTitle']);
          } else {
            this.titleService.setTitle(data['title']);
          }
 
          if (data['description']) {
            this.metaService.removeTag("name='description'");
            if (locality) {
              if (pageTexts[locality])
                this.metaService.updateTag({ name: 'description', content: pageTexts[locality]['metaDescription'] });
            } else if (filter) {
              if (pageTexts[filter])
                this.metaService.updateTag({ name: 'description', content: pageTexts[filter]['metaDescription'] });
            } else {
              this.metaService.updateTag({ name: 'description', content: data['description'] });
            }
          } else {
            this.metaService.removeTag("name='description'");
          }
 
          if (data['robots']) {
            this.metaService.updateTag({ name: 'robots', content: data['robots'] });
          } else {
            this.metaService.updateTag({ name: 'robots', content: "follow,index" });
            if (locality) {
              if (this.noIndexLocalities.includes(locality)) {
                this.metaService.updateTag({ name: 'robots', content: "noindex,nofollow" });
              }
            }
          }

          if (data['canonical']) {
            this.updateCanonicalUrl(data['canonical']);
          } else {
            this.updateCanonicalUrl(domain + this.router.url);
          }
 
          if (data['ogUrl']) {
            this.metaService.updateTag({ property: 'og:url', content: data['ogUrl'] });
          } else {
            this.metaService.updateTag({ property: 'og:url', content: domain + this.router.url });
          }
 
          if (data['ogTitle']) {
            this.metaService.removeTag("property='og:title'");
            if (locality) {
              if (pageTexts[locality])
                this.metaService.updateTag({ property: 'og:title', content: pageTexts[locality]['metaTitle'] });
            } else if (filter) {
              if (pageTexts[filter])
              this.metaService.updateTag({ property: 'og:title', content: pageTexts[filter]['metaTitle'] });
            } else {
              this.metaService.updateTag({ property: 'og:title', content: data['ogTitle'] });
            }
          } else {
            this.metaService.removeTag("property='og:title'");
          }
 
          if (data['ogDescription']) {
            this.metaService.removeTag("property='og:description'");
            if (locality) {
              if (pageTexts[locality])
                this.metaService.updateTag({ property: 'og:description', content: pageTexts[locality]['metaDescription'] });
            } else if (filter) {
              if (pageTexts[filter])
                this.metaService.updateTag({ property: 'og:description', content: pageTexts[filter]['metaDescription'] });
            } else {
              this.metaService.updateTag({ property: 'og:description', content: data['ogDescription'] });
            }
          } else {
            this.metaService.removeTag("property='og:description'");
          }
 
          if (data['ogImage']) {
            this.metaService.updateTag({ property: 'og:image', content: data['ogImage'] });
          } else {
            this.metaService.removeTag("property='og:image'");
          }

          if (data['twitterUrl']) {
            this.metaService.updateTag({ name: 'twitter:url', content: data['twitterUrl'] });
          } else {
            this.metaService.updateTag({ name: 'twitter:url', content: domain + this.router.url });
          }

          if (data['twitterTitle']) {
            this.metaService.removeTag("name='twitter:title'");
            if (locality) {
              if (pageTexts[locality])
                this.metaService.updateTag({ name: 'twitter:title', content: pageTexts[locality]['metaTitle'] });
            } else if (filter) {
              if (pageTexts[filter])
                this.metaService.updateTag({ name: 'twitter:title', content: pageTexts[filter]['metaTitle'] });
            } else {
              this.metaService.updateTag({ name: 'twitter:title', content: data['twitterTitle'] });
            }
          } else {
            this.metaService.removeTag("name='twitter:title'");
          }
 
          if (data['twitterDescription']) {
            this.metaService.removeTag("name='twitter:description'");
            if (locality) {
              if (pageTexts[locality])
                this.metaService.updateTag({ name: 'twitter:description', content: pageTexts[locality]['metaDescription'] });
            } else if (filter) {
              if (pageTexts[filter])
                this.metaService.updateTag({ name: 'twitter:description', content: pageTexts[filter]['metaDescription'] });
            } else {
              this.metaService.updateTag({ name: 'twitter:description', content: data['twitterDescription'] });
            }
          } else {
            this.metaService.removeTag("name='twitter:description'");
          }
 
          if (data['twitterImage']) {
            this.metaService.updateTag({ name: 'twitter:image', content: data['twitterImage'] });
          } else {
            this.metaService.removeTag("name='twitter:image'");
          }
      });
    });
    this.config.setTranslation({
        accept: 'Accept',
        reject: 'Cancel',
        apply: 'Aplicar',
        clear: 'Limpiar'
        //translations
    });
  }

  getChild(activatedRoute: ActivatedRoute): ActivatedRoute {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  updateCanonicalUrl(url:string){
    const head = this.document.getElementsByTagName('head')[0];
    var element: HTMLLinkElement | null = this.document.querySelector(`link[rel='canonical']`) || null;
    if (element==null) {
      element= this.document.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel','canonical')
    element.setAttribute('href',url)
  }

}
